<template>
    <div>
      <main id="rate-assist-content">
        <section class="rate-assist-settings-outer" id="rateassist-tab-top">
          <section class="adv-tabs">
            <div data-toggle="tooltip" title="Basic Details" :class="[tab === 'basicDetails' ? 'active' : '', 'tab' ]" @click="tab = 'basicDetails'">
              <i class="fa fa-cogs"></i>
            </div>
            <div data-toggle="tooltip" title="Locations" :class="[tab === 'locations' ? 'active' : '', 'tab' ]" @click="tab = 'locations'">
              <i class="fa fa-location-arrow"></i>
            </div>
            <div data-toggle="tooltip" title="Breakpoints" :class="[ tab === 'breakpoints' ? 'active' : '', 'tab' ]" @click="tab = 'breakpoints'">
              <i class="fa fa-arrows-h"></i>
            </div>
            <div v-if="showDistances" data-toggle="tooltip" title="Distances" :class="[ tab === 'distances' ? 'active' : '', 'tab' ]" @click="tab = 'distances'">
              <i class="fa fa-map-signs"></i>
            </div>
            <div data-toggle="tooltip" title="Accessorials" :class="[ tab === 'accessories' ? 'active' : '', 'tab' ]" @click="tab = 'accessories'">
              <i class="fa fa-asterisk"></i>
            </div>
            <div data-toggle="tooltip" title="Build" :class="[ isValid ? '' : 'disabled', tab === 'build' ? 'active' : '', 'tab' ]" @click="build">
              <i class="fa fa-check" :class="[ isValid ? '' : 'disabled' ]"></i>
            </div>
          </section>
        </section>
        <section id="rate-assist-provider-column">
          <div class="row">
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="form-label" for="rate-assist-provider">Service Provider</label>
                <autocomplete
                  :dataset="partySearchResults"
                  title="Just start typing!"
                  placeHolder="Select a Service Provider"
                  :initVal="rate.serviceProvider"
                  v-on:changing="data => partySearchText = data"
                  :fnFormatText="displayParty"
                  :fnSelectValue="displayParty"
                  v-on:selection-made="updateServiceProvider"
                  :autoFocus="true"
                />
              </div>
            </div>
            <div class="col-xs-12 col-md-5">
              <div class="form-group">
                <label class="form-label" for="rate-assist-tariff-profile-type">Tariff Profile Type</label>
                <select v-model="rate.lookupProfileType" id="rate-assist-tariff-profile-type" class="form-control">
                  <option value=""></option>
                  <option v-for="option in tariffTypes" :value="option.id">{{ option.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-md-2">
              <div class="btn btn-success sq fw" @click="save">
                {{ saveOrUpdate }}
              </div>
            </div>
          </div>
        </section>
        <div id="rateassist-tab-content">
          <div class="white">
            <basic-details
              v-show="tab === 'basicDetails'"
              v-on:updating="update"
              :containerTypeShouldShow="containerTypeShouldShow"
              :woodLooseShouldShow="woodLooseShouldShow"
              :modeShouldShow="modeShouldShow"
              :details="rate">
            </basic-details>
            <location-details
              v-show="tab === 'locations'"
              v-on:updating="update"
              :showPreCarriage="showPreCarriage"
              :showOnCarriage="showOnCarriage"
              :showOrigin="showOrigin"
              :showDestination="showDestination"
              :details="rate"
              >
            </location-details>
            <breakpoints
              :bp="rate.breakpointsPer"
              v-on:updating="update"
              :details="rate"
              v-show="tab === 'breakpoints'">
            </breakpoints>
            <distances
              :dt="rate.distanceType"
              :details="rate"
              v-on:updating="update"
              v-show="tab === 'distances' && showDistances">
            </distances>
            <accessorials
              :accs="rate.accessorials"
              v-on:updating="update"
              v-show="tab === 'accessories'"
              >
            </accessorials>
            <!--
            <results
              :cartesianHeaders="cartesianHeaders"
              :cartesianElements="cartesianElements"
              :commonData="spreadSheet"
              v-show="tab === 'build'"
            >
            </results>
            -->
            <lookups
              :woodLoose="shouldShowProp('woodLooseSelections') ? rate.woodLooseSelections.map(({dataOption}) => dataOption) : []"
              :containerTypes="shouldShowProp('containerTypeSelections') ? rate.containerTypeSelections.map(({dataOption}) => dataOption) : []"
              :common="spreadSheet"
              :cartesianHeaders="cartesianHeaders"
              :cartesianElements="cartesianElements"
              v-show="tab === 'build'"
              :details="rate"
              :visible="tab === 'build'"
              :tariffCode="tariffCode"
            >
            </lookups>
          </div>
        </div>
        <section class="rate-assist-settings-outer" id="rateassist-tab-btm">
          <section class="adv-tabs">
            <div data-toggle="tooltip" title="Basic Details" :class="[tab === 'basicDetails' ? 'active' : '', 'tab' ]" @click="tab = 'basicDetails'">
              <i class="fa fa-cogs"></i>
            </div>
            <div data-toggle="tooltip" title="Locations" :class="[tab === 'locations' ? 'active' : '', 'tab' ]" @click="tab = 'locations'">
              <i class="fa fa-location-arrow"></i>
            </div>
            <div data-toggle="tooltip" title="Breakpoints" :class="[ tab === 'breakpoints' ? 'active' : '', 'tab' ]" @click="tab = 'breakpoints'">
              <i class="fa fa-arrows-h"></i>
            </div>
            <div v-if="showDistances" data-toggle="tooltip" title="Distances" :class="[ tab === 'distances' ? 'active' : '', 'tab' ]" @click="tab = 'distances'">
              <i class="fa fa-map-signs"></i>
            </div>
            <div data-toggle="tooltip" title="Accessorials" :class="[ tab === 'accessories' ? 'active' : '', 'tab' ]" @click="tab = 'accessories'">
              <i class="fa fa-asterisk"></i>
            </div>
            <div data-toggle="tooltip" title="Build" :class="[ isValid ? '' : 'disabled', tab === 'build' ? 'active' : '', 'tab' ]" @click="build">
              <i class="fa fa-check"></i>
            </div>
          </section>
        </section>
      </main>
    </div>
</template>
<script>
  import BasicDetails from './BasicDetails'
  import LocationDetails from './LocationDetails'
  import Breakpoints from './Breakpoints'
  import Distances from './Distances'
  import Results from './Results'
  import Accessorials from './Accessorials'
  import Lookups from './Lookups'
  import SearchHeader from './SearchHeader'
  import Autocomplete from '../../helpers/AutoComplete'
  import { fromTimestamp } from '../../helpers/DateHelpers'
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  import API from '../../../api/endpoints'
  import event from '../../../event'
  import Composite from '../../../Composite'
  import { decryptQueryString, addCryptRouteId, createRouteIdHash } from '../../helpers/RouteHash'
  export default {
    name: 'RateAssist',
    mixins: [ LookupHelperMixin ],
    components: {
      BasicDetails,
      Autocomplete,
      LocationDetails,
      Breakpoints,
      Distances,
      Results,
      Accessorials,
      Lookups,
      SearchHeader
    },
    data () {
      return {
        tab: 'basicDetails',
        rate: {
          id: null,
          accessorials: [],
          serviceProvider: null,
          lookupProfileType: '',
          serviceContract: '',
          description: '',
          notes: '',
          effectiveTo: window.getYMDDate(),
          effectiveFrom: window.getYMDDate(),
          mode: '',
          ratesPer: '',
          density: 6.5,
          serviceClass: '',
          densityType: '',
          woodLooseSelections: [],
          containerTypeSelections: [],
          preCarriage: [],
          origin: [],
          destination: [],
          onCarriage: [],
          distanceType: null,
          distanceEntries: [],
          breakpointsPer: null,
          breakpointEntries: []
        },
        locationCategories: ['origin', 'destination', 'onCarriage', 'preCarriage']
      }
    },
    computed: {
      saveOrUpdate () {
        return this.rate.id === null ? 'Save' : 'Update'
      },
      profileElements () {
        let visibilityStatusToPropMap = {
          woodLooseShouldShow: 'woodLooseSelections',
          containerTypeShouldShow: 'containerTypeSelections',
          showOrigin: 'origin',
          showDestination: 'destination',
          showOnCarriage: 'onCarriage',
          showPreCarriage: 'preCarriage',
          showBreakpoints: 'breakpointEntries',
          showDistances: 'distanceEntries'
        }
        let elements = []
        for (let prop in visibilityStatusToPropMap) {
          if (this[prop]) {
            elements.push(...this.rate[visibilityStatusToPropMap[prop]])
          }
        }
        return elements
      },
      requestBody () {
        return {
          profile: {
            id: this.rate.id,
            serviceProvider: this.rate.serviceProvider !== null && this.rate.serviceProvider.hasOwnProperty('id') ? this.rate.serviceProvider.id : null,
            lookupProfileType: this.rate.lookupProfileType,
            serviceContract: this.rate.serviceContract,
            description: this.rate.description,
            notes: this.rate.notes,
            breakpointsPer: this.rate.breakpointsPer,
            effectiveFrom: this.rate.effectiveFrom,
            effectiveTo: this.rate.effectiveTo,
            densityType: this.rate.densityType,
            distanceType: this.rate.distanceType,
            ratesPer: this.rate.ratesPer,
            mode: this.rate.mode,
            density: this.rate.density,
            serviceClass: this.rate.serviceClass
          },
          elements: this.profileElements,
          accessorials: this.rate.accessorials
        }
      },
      isValid () {
        return this.requestBody.profile.serviceProvider !== null && this.rate.lookupProfileType !== ''
      },
      profileId () {
        if (this.$route.params.hasOwnProperty('id')) {
          return addCryptRouteId(this.$route.params.id)
        }
        return null
      },
      cartesianElements () {
        let objs = [
          'distanceEntries',
          'breakpointEntries'
        ]
        let product = []
        this.locationCategories.forEach(prop => {
          if (this.shouldShowProp(prop) && this.rate[prop].length > 0) {
            product.push(this.rate[prop].map(({location}) => {
              return {
                [prop + 'Town']: location.name,
                [prop + 'State']: location.subdivision,
                [prop + 'Country']: location.hasOwnProperty('country') && location.country !== null ? location.country.code : null
              }
            }))
          } else if (this.shouldShowProp(prop)) {
            product.push([null])
          }
        })
        objs.forEach(prop => {
          if (this.shouldShowProp(prop) && this.rate[prop].length > 0) {
            product.push(this.rate[prop].map(({minimumValue, maximumValue}) => {
              let suffix = prop === 'distanceEntries' ? 'Distance' : 'Breakpoint'
              return {
                ['minimum' + suffix]: minimumValue,
                ['maximum' + suffix]: maximumValue
              }
            }))
          }
        })
        return product
      },
      cartesianHeaders () {
        let product = []
        this.locationCategories.forEach(prop => {
          if (this.shouldShowProp(prop)) {
            product.push(prop)
          }
        })
        let objs = ['distanceEntries', 'breakpointEntries']
        objs.forEach(prop => {
          if (this.shouldShowProp(prop) && this.rate[prop].length > 0) {
            product.push(prop)
          }
        })
        return product
      },
      tariffTypes () {
        return this.getSystemOptions('LOOKUP_PROFILE_TYPE').sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      },
      showBreakpoints () {
        return true
      },
      modeShouldShow () {
        let tariffTypeCodes = [
          'DSF',
          'DSF_NONUS',
          'ORF',
          'ORF_NONUS',
          'FR',
          'PC',
          'OC',
          'LH_OTHER',
          'DSL',
          'DSL_NONUS',
          'DSA',
          'DSA_NONUS',
          'DSG',
          'DSG_NONUS',
          'POR',
          'ORL',
          'ORL_NONUS',
          'ORA',
          'ORA_NONUS',
          'ORG',
          'ORG_NONUS',
          'LH',
          'LH_WAIT'
        ]
        return this.tariffCode && tariffTypeCodes.includes(this.tariffCode)
      },
      containerTypeShouldShow () {
        let tariffTypeCodes = ['FR', 'PC', 'OC', 'AUTO', 'APC', 'AOC', 'ORF', 'ORF_NONUS', 'LH', 'LH_WAIT', 'DSF', 'DSF_NONUS']
        return this.tariffCode && tariffTypeCodes.includes(this.tariffCode)
      },
      woodLooseShouldShow () {
        return this.containerTypeShouldShow
      },
      tariffCode () {
        let tariff = this.systemOptions.find(({id}) => id === this.rate.lookupProfileType)
        return tariff ? tariff.code : null
      },
      showOrigin () {
        let tariffTypeCodes = ['OC', 'FRLOC', 'AOC', 'AIROC']
        return this.tariffCode && !tariffTypeCodes.includes(this.tariffCode)
      },
      showDestination () {
        let tariffTypeCodes = ['PC', 'FRLPC', 'APC', 'AIRPC', 'POR']
        return this.tariffCode && !tariffTypeCodes.includes(this.tariffCode)
      },
      showPreCarriage () {
        let tariffTypeCodes = ['PC', 'FRLPC', 'APC', 'AIRPC', 'DSF_NONUS', 'DSL', 'DSL_NONUS', 'DSA', 'DSA_NONUS', 'DSG', 'DSG_NONUS']
        return this.tariffCode && tariffTypeCodes.includes(this.tariffCode)
      },
      showOnCarriage () {
        let tariffTypeCodes = ['OC', 'FRLOC', 'AOC', 'AIROC', 'ORL', 'ORL_NONUS', 'ORA', 'ORA_NONUS', 'ORG', 'ORG_NONUS', 'ORF_NONUS']
        return this.tariffCode && tariffTypeCodes.includes(this.tariffCode)
      },
      showDistances () {
        let tariffTypeCodes = ['ORF', 'ORF_NONUS', 'ORL', 'ORL_NONUS', 'ORA', 'ORA_NONUS', 'ORG', 'ORG_NONUS', 'LH_OTHER', 'DSF', 'DSF_NONUS', 'DSL', 'DSL_NONUS', 'DSA', 'DSA_NONUS', 'DSG', 'DSG_NONUS']
        return this.tariffCode && tariffTypeCodes.includes(this.tariffCode)
      },
      spreadSheet () {
        let excludes = [
          'woodLooseSelections',
          'containerTypeSelections',
          'origin',
          'destination',
          'onCarriage',
          'preCarriage',
          'distanceEntries',
          'breakpointEntries',
          'serviceProvider',
          'accessorials'
        ]
        let sheet = {}
        for (let prop in this.rate) {
          if (excludes.includes(prop)) {
            continue
          }
          sheet[prop] = this.rate[prop]
        }
        sheet.serviceProvider = this.rate.serviceProvider ? this.rate.serviceProvider.code : null
        return sheet
      },
      saveUrl () {
        return this.rate.id === null ? API.SAVE_LOOKUP_PROFILE : API.UPDATE_LOOKUP_PROFILE(this.rate.id)
      },
      saveMethod () {
        return this.rate.id === null ? 'post' : 'put'
      },
      isSave () {
        return this.saveMethod === 'post'
      },
      isUpdate () {
        return !this.isSave
      },
      isClonePage () {
        return this.$route.path.match('/rate-assist/clone/') !== null
      },
      isNewPage () {
        return this.profileId === null
      },
      isUpdatePage () {
        return !this.isClonePage && this.profileId !== null && this.profileId > 0
      },
      defaultRatesPer () {
        let opt = this.getDefault('DISPLAY_RATE_PER')
        return opt ? opt.id : null
      },
      defaultMode () {
        let opt = this.getDefault('MODE')
        return opt && this.modeShouldShow ? opt.id : null
      }
    },
    watch: {
      '$route' (newVal, oldVal) {
        this.init()
      }
    },
    methods: {
      unbox (obj, propsToUnbox = false) {
        let data = {}
        for (let prop in obj) {
          if (typeof obj[prop] === 'object' && obj[prop] !== null && obj[prop].hasOwnProperty('id') && (!propsToUnbox || propsToUnbox.includes(prop))) {
            data[prop] = obj[prop].id
          } else {
            data[prop] = obj[prop]
          }
        }
        return data
      },
      init () {
        if (this.isClonePage) {
          this.doFetch(true)
        } else if (this.isUpdatePage) {
          this.doFetch(false)
        } else {
          this.doClear()
        }
      },
      updateRate (obj) {
        for (let prop in obj) {
          if (['effectiveTo', 'effectiveFrom'].includes(prop)) {
            this.rate[prop] = fromTimestamp(obj[prop])
          } else {
            this.rate[prop] = obj[prop]
          }
        }
      },
      doClear () {
        this.tab = 'basicDetails'
        let clearData = {
          id: null,
          accessorials: [],
          serviceProvider: null,
          lookupProfileType: '',
          serviceContract: '',
          description: '',
          notes: '',
          effectiveTo: window.getYMDDate(),
          effectiveFrom: window.getYMDDate(),
          mode: this.defaultMode,
          ratesPer: this.defaultRatesPer,
          density: 6.5,
          densityType: '',
          serviceClass: '',
          woodLooseSelections: [],
          containerTypeSelections: [],
          preCarriage: [],
          origin: [],
          destination: [],
          onCarriage: [],
          distanceType: null,
          distanceEntries: [],
          breakpointsPer: null,
          breakpointEntries: []
        }
        this.updateRate(clearData)
      },
      doFetch (clearIdsForClone) {
        this.doClear()
        event.$emit('loading-on', { title: 'Loading Profile' })
        let profile = this.getProfile(this.profileId, clearIdsForClone)
        let accs = this.getAccessorials(this.profileId, clearIdsForClone)
        let eles = this.getElements(this.profileId, clearIdsForClone)
        Promise.all([profile, accs, eles]).then(() => {})
        .catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'Unable to load resources' })
        }).then(() => event.$emit('loading-off', {}))
      },
      getProfile (id, isClone) {
        return new Promise((resolve, reject) => {
          this.$http.get(API.GET_ADMIN_ENTITY_BY_ID('lookup-profile', this.profileId))
          .then(({data}) => {
            if (isClone) {
              data.id = null
              data.serviceProvider = null
            }
            data = this.unbox(data, [ 'distanceType', 'breakpointsPer', 'densityType', 'mode', 'ratesPer', 'lookupProfileType', 'serviceClass' ])
            this.updateRate(data)
            resolve()
          }).catch(err => {
            console.log(err)
            reject()
          })
        })
      },
      getElements (lookupProfile, isClone) {
        return new Promise((resolve, reject) => {
          this.$http.get(API.GET_ENTITIES('lookup-profile-element'), { params: { lookupProfile }, headers: { 'X-Lazy-Fetch': '0' } })
          .then(({data}) => {
            let elements = data.map(obj => {
              return this.unbox(obj, ['dataOptionId'])
            }).map(obj => {
              return { ...obj, id: null }
            })
            this.splitAndUpdate(elements)
            resolve()
          }).catch(err => {
            console.log(err)
            reject()
          })
        })
      },
      splitAndUpdate (elements) {
        let categoryToPropMap = {
          WOOD_LOOSE: 'woodLooseSelections',
          CONTAINER_TYPE: 'containerTypeSelections',
          ORIGIN: 'origin',
          DESTINATION: 'destination',
          ON_CARRIAGE: 'onCarriage',
          PRE_CARRIAGE: 'preCarriage',
          BREAKPOINT_UNIT: 'breakpointEntries',
          DISTANCE_TYPE: 'distanceEntries'
        }
        for (let prop in categoryToPropMap) {
          this.rate[categoryToPropMap[prop]] = elements.filter(({category}) => category === prop)
          if (this.locationCategories.includes(categoryToPropMap[prop])) {
            this.rate[categoryToPropMap[prop]] = this.rate[categoryToPropMap[prop]].filter(elem => elem.location)
          }
        }
      },
      getAccessorials (lookupProfile, isClone) {
        return new Promise((resolve, reject) => {
          this.$http.get(API.GET_ENTITIES('lookup-addition'), { params: { lookupProfile } })
          .then(({data}) => {
            this.updateRate({
              accessorials: data.map(obj => this.unbox(obj)).map(obj => {
                return {
                  ...obj,
                  id: null
                }
              })
            })
            resolve()
          }).catch(err => {
            console.log(err)
            reject()
          })
        })
      },
      handleSave (id) {
        if (this.isSave) {
          this.$router.push({ name: 'RateAssist - View/Update Profile', params: { id: createRouteIdHash(id) } })
        }
      },
      save () {
        if (this.isValid) {
          event.$emit('loading-on', { title: 'Saving Profile' })
          this.$http[this.saveMethod](this.saveUrl, this.requestBody)
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'Profile saved' })
            this.handleSave(data.id)
            console.log(data)
          }).catch(err => {
            console.log(err)
          }).then(() => {
            event.$emit('loading-off')
          })
        } else {
          event.$emit('toast', { type: 'warning', message: 'Ensure a service provider is selected.' })
        }
      },
      shouldShowProp (prop) {
        let propToValue = {
          'woodLooseSelections': 'woodLooseShouldShow',
          'containerTypeSelections': 'containerTypeShouldShow',
          'origin': 'showOrigin',
          'destination': 'showDestination',
          'onCarriage': 'showOnCarriage',
          'preCarriage': 'showPreCarriage',
          'distanceEntries': 'showDistances',
          'breakpointEntries': 'showBreakpoints'
        }
        return propToValue.hasOwnProperty(prop) ? this[propToValue[prop]] : false
      },
      build () {
        if (!this.isValid) {
          event.$emit('toast', { type: 'warning', message: 'Complete all required fields before building tariffs' })
        } else {
          this.tab = 'build'
        }
      },
      update (obj) {
        for (let prop in obj) {
          this.rate[prop] = obj[prop]
        }
      },
      updatePartySearchResults (str) {
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('party'), { params: { name: str, category: 'SP' } })
          .then(({data}) => {
            if (str === this.partySearchText) {
              this.partySearchResults = data
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      updateServiceProvider (party) {
        this.rate.serviceProvider = party
        this.partySearchText = ''
        this.partySearchResults = []
      }
    },
    mounted () {
      this.init()
    }
  }
</script>
<style scoped>
.fa {
  cursor: pointer !important;
}
#rateassist-tab-top {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
#rateassist-tab-btm {
  border-top: 1px solid #eee;
}
#rateassist-tab-content {
  min-height: 125px;
  padding: 20px 10px;
  background: #fff;
  border-top: 1px solid #eee;
}
div.white {
  background: #fff;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  transition: all 0.5s;
  padding: 10px;
}
div.white:hover {
  -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
}
#rate-assist-content .tab {
  padding: 20px 5px;
}
#rate-assist-provider-column {
  background: #fff;
  padding: 20px;
}
.adv-tabs {
  padding: 0 20px;
  overflow-x: auto;
  overflow-y: hidden;
}
.tab.active .fa-check {
  color: #00a65a;
}
.fw {
  margin-top: 25px;
  width: 100%;
}
.fa.disabled {
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// RateAssist.vue?6864e644